var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { "sidebar-collapse": _vm.isSidebarCollapsed } }, [
    _c("div", { staticClass: "top-header" }, [
      _c(
        "div",
        { staticClass: "sidebar text-center" },
        [
          _c(
            "router-link",
            {
              attrs: { to: "/sadmin/dashboard" },
              nativeOn: {
                click: function($event) {
                  return _vm.$emit("sidebarCollapsed")
                }
              }
            },
            [
              _c("img", {
                staticClass: "sidebar-logo",
                attrs: { src: "/img/Dashboard/HeaderLogo.png" }
              })
            ]
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "below-header" }, [
      _c("div", { staticClass: "sidebar" }, [
        _c("div", { staticClass: "sidebar-inner sidebar-mobile" }, [
          _vm.$store.state.userData
            ? _c("div", { staticClass: "sidebar-profile" }, [
                _c("img", {
                  staticClass: "profile-photo-sidebar",
                  attrs: {
                    src:
                      _vm.$store.state.userData.image + "?fit=crop&w=150&h=150"
                  },
                  on: {
                    error: function($event) {
                      return _vm.$common.getDefaultImage("user")
                    }
                  }
                }),
                _c(
                  "div",
                  { staticClass: "profile-details" },
                  [
                    _c("h4", [_vm._v(_vm._s(_vm.$store.state.userData.name))]),
                    _c(
                      "router-link",
                      {
                        staticClass: "grey-link",
                        attrs: { to: "/sadmin/profile" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.$emit("sidebarCollapsed")
                          }
                        }
                      },
                      [_vm._v("View Profile")]
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.logout }
                      },
                      [_vm._v("Log Out")]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "clear" })
              ])
            : _vm._e(),
          _c("ul", [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "home-cls",
                    attrs: { to: "/sadmin/dashboard" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Home")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "pickl-cls",
                    attrs: { to: "/sadmin/campaigns" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Campaigns")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "alerts-cls",
                    attrs: { to: "/sadmin/pickls" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Geo-Location")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "alerts-cls",
                    attrs: { to: "/sadmin/non-geo-pickls" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Go-Anywhere")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "picklrs-cls",
                    attrs: { to: "/sadmin/picklrs" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Users")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "brands-cls",
                    attrs: { to: "/sadmin/brands" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Companies")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tasks-cls",
                    attrs: { to: "/sadmin/tasks" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Task Images")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tasks-cls",
                    attrs: { to: "/sadmin/task-data-points" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Data Points")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "stores-cls",
                    attrs: { to: "/sadmin/stores" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Venue/Merchant")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "locations-cls",
                    attrs: { to: "/sadmin/store-locations" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Locations")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "offers-cls",
                    attrs: { to: "/sadmin/coupons" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Deal Drops")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "locations-cls",
                    attrs: { to: "/sadmin/cities" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Cities")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "pakcs-cls",
                    attrs: { to: "/sadmin/packs" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Pricing")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "settings-cls",
                    attrs: { to: "/sadmin/settings" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Settings")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "staff-cls",
                    attrs: { to: "/sadmin/staff" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Staff")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "countries-cls",
                    attrs: { to: "/sadmin/countries" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Countries")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "offers-cls",
                    attrs: { to: "/sadmin/offers" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Company Offers")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "offers-cls",
                    attrs: { to: "/sadmin/brand-tutorial-videos" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Tutorials")]
                )
              ],
              1
            ),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "staff-cls",
                    attrs: { to: "/sadmin/user-referrals" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$emit("sidebarCollapsed")
                      }
                    }
                  },
                  [_vm._v("Referrals")]
                )
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          { staticClass: "sidebar-desktop" },
          [
            _c("VuePerfectScrollbar", { staticClass: "scroll-height" }, [
              _c("div", { staticClass: "sidebar-inner" }, [
                _vm.$store.state.userData
                  ? _c("div", { staticClass: "sidebar-profile" }, [
                      _c("img", {
                        staticClass: "profile-photo-sidebar",
                        attrs: {
                          src:
                            _vm.$store.state.userData.image ||
                            _vm.$common.getDefaultImage("user")
                        },
                        on: {
                          error: function($event) {
                            return _vm.$common.getDefaultImage("user")
                          }
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "profile-details" },
                        [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.$store.state.userData.name))
                          ]),
                          _c(
                            "router-link",
                            {
                              staticClass: "grey-link",
                              attrs: { to: "/sadmin/profile" }
                            },
                            [_vm._v("View Profile")]
                          ),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:;" },
                              on: { click: _vm.logout }
                            },
                            [_vm._v("Log Out")]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "clear" })
                    ])
                  : _vm._e(),
                _c("ul", [
                  _c(
                    "li",
                    { staticClass: "live_chat_menu" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "packs-cls",
                          attrs: { to: "/sadmin/live-chat" }
                        },
                        [
                          _vm._v("Live Chat "),
                          _c("span", [_vm._v(_vm._s(_vm.ongoingCount))])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "home-cls",
                          attrs: { to: "/sadmin/dashboard" }
                        },
                        [_vm._v("Home")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "home-cls",
                          attrs: { to: "/sadmin/campaigns" }
                        },
                        [_vm._v("Campaigns")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "settings-cls",
                          attrs: { to: "/sadmin/settings" }
                        },
                        [_vm._v("Settings")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "brands-cls",
                          attrs: { to: "/sadmin/payout-requests" }
                        },
                        [_vm._v("Payouts")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "staff-cls",
                          attrs: { to: "/sadmin/staff" }
                        },
                        [_vm._v("Staff")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "brands-cls",
                          attrs: { to: "/sadmin/brands" }
                        },
                        [_vm._v("Companies")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "brands-cls",
                          attrs: { to: "/sadmin/plg-brands" }
                        },
                        [_vm._v("PLG Companies")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "alerts-cls",
                          attrs: { to: "/sadmin/pickls" }
                        },
                        [_vm._v("Geo-Located")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "non-geo-pickl-cls",
                          attrs: { to: "/sadmin/non-geo-pickls" }
                        },
                        [_vm._v("Go-Anywhere")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "alerts-cls",
                          attrs: { to: "/sadmin/plg-campaigns" }
                        },
                        [_vm._v("PLG Campaigns")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "picklrs-cls",
                          attrs: { to: "/sadmin/picklrs" }
                        },
                        [_vm._v("Users")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "staff-cls",
                          attrs: { to: "/sadmin/user-referrals" }
                        },
                        [_vm._v("Referrals")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "tasks-cls",
                          attrs: { to: "/sadmin/tasks" }
                        },
                        [_vm._v("Task Images")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "tasks-cls",
                          attrs: { to: "/sadmin/task-data-points" }
                        },
                        [_vm._v("Data Points")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "stores-cls",
                          attrs: { to: "/sadmin/stores" }
                        },
                        [_vm._v("Venue/Merchant")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "locations-cls",
                          attrs: { to: "/sadmin/store-locations" }
                        },
                        [_vm._v("Locations")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "locations-cls",
                          attrs: { to: "/sadmin/cities" }
                        },
                        [_vm._v("Cities")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "locations-cls",
                          attrs: { to: "/sadmin/targeted-cities" }
                        },
                        [_vm._v("Targeted Cities")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "countries-cls",
                          attrs: { to: "/sadmin/countries" }
                        },
                        [_vm._v("Countries")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "offers-cls",
                          attrs: { to: "/sadmin/offers" }
                        },
                        [_vm._v("Company Offers")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "offers-cls",
                          attrs: { to: "/sadmin/coupons" }
                        },
                        [_vm._v("Deal Drops")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "offers-cls",
                          attrs: { to: "/sadmin/brand-tutorial-videos" }
                        },
                        [_vm._v("Tutorials")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "packs-cls",
                          attrs: { to: "/sadmin/packs" }
                        },
                        [_vm._v("Pricing")]
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }